
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { isOptionalGoodsPackage } from '@/api/shoppingMall'
import { PackageListDto, RuleListDto, SelectSKUListDto } from '@/api/buyCar'
import {
  getCyGoodsSpecificationList,
  ShopGoodsInfoDto,
  batchAddStoreShoppingCart
} from '@/api/industryMall'
import { isContained } from '@/components/PackageSelector/packageSelector'
import { Action, Getter } from 'vuex-class'
import StepperTemp from '@/components/StepperTemp/index.vue'
import { LoginReturnDataDto } from '@/utils/h5ToApp'
import store from '@/store'
import { handleAmount, handlePercentage, moneyFormat, printFn } from '@/utils/util'
import { number } from 'mathjs'

@Component({
  name: 'PackageSelector',
  components: { StepperTemp }
})
export default class PackageSelector extends Vue {
  @Getter providerId!: string // 店铺编号
  @Getter companyId!: string
  @Getter info!: LoginReturnDataDto
  @Action setPreOrderParams!: (val) => void
  @Prop({ default: () => {} }) storeInfo?: any

  showRules = false
  packageList = [] // 规格信息
  goodsId = ''
  goodsName = ''
  mainImageUrl = ''
  goodsPrice = 0
  selectedQuantity = 0
  selectedMoney = ''
  goodsDetail:any = {}

  @Watch('packageList', { deep: true, immediate: true })
  handlePackageList(val: any) {
    let quantity = 0
    let money = 0
    val.forEach(item => {
      quantity += item.orderQuantity
      money += item.orderQuantity * (item.finalPrice || item.marketPrice)
    })
    this.selectedQuantity = quantity
    this.selectedMoney = moneyFormat(money)
  }

  // 处理价格
  sellPrice(item) {
    let price = 0
    // 阶梯定价
    if (item.levelPriceList && item.levelPriceList.length) {
      const fuHe = item.levelPriceList.find(element => item.orderQuantity >= element.minAmount && (item.orderQuantity < element.maxAmount || !element.maxAmount))
      if (fuHe) {
        price = fuHe.finalPrice
      } else {
        price = item.marketPrice
      }
    } else {
      price = item.finalPrice
    }
    item.finalPrice = price // 当前区间价格
  }

  show(data: {
    detailInfo?: ShopGoodsInfoDto
    selectList?: string[]
    defaultInfo?: ShopGoodsInfoDto
    packageList?: PackageListDto[]
  }) {
    this.showRules = true
    this.goodsId = data.detailInfo.goodsId
    this.goodsName = data.detailInfo.goodsName
    this.mainImageUrl = data.detailInfo.goodsMainImage || data.detailInfo.imageUrl
    this.goodsPrice = data.detailInfo.goodsPrice
    this.goodsDetail = data.detailInfo
    console.log(this.goodsDetail, 'this.goodsDetail');

    // this.selectItemList = []
    // this.packageList = data.packageList
    // if (data.detailInfo) {
    //   // this.selectPackageInfo = Object.assign(this.selectPackageInfo, data.detailInfo)
    //   this.goodsId = data.detailInfo.goodsId
    //   this.goodsName = data.detailInfo.goodsName
    //   this.mainImageUrl = data.detailInfo.goodsMainImage
    //   // this.goodsPrice = data.detailInfo.goodsPriceMin
    //   this.packageCount = data.detailInfo.packageCount
    //   // isMultiSpec	是否为多规格	Boolean
    //   this.isMultiSpec = data.detailInfo.isMultiSpec as boolean
    // }
    // this.defaultInfo = data.defaultInfo || {}
    // if (data.selectList && data.selectList.length > 0) {
    //   this.selectValueList = data.selectList
    // } else {
    //   this.selectValueList = []
    // }
    this.getCyGoodsSpecificationList()
  }

    /**
   * 加入购物车
   * */
  async joinBuyCar() {
    console.log(this.packageList, 'packageList');

    let params = {
      // 合作方id
      partnerCompanyId: this.info.partnerCompanyId,
      // storeId: this.storeInfo.companyId,
      storeId: this.$route.query.storeId || this.goodsDetail.storeId,
      goodsInfoList: this.packageList
      // goodsId: this.goodsId,
      // packageId: this.selectPackageInfo.packageId,
      // orderQuantity: +this.orderQuantity
    }
    const res = await batchAddStoreShoppingCart(params)
    if (res.code === '000000') {
      this.$toast.success({
        message: '已添加到购物车中',
        duration: 500,
        onClose: () => {
          // this.$emit(
          //   'getSelectPackageInfo',
          //   this.selectPackageInfo,
          //   this.selectValueList
          // )
          this.showRules = false
        }
      })
      store.dispatch('getShopCarNum', this.info.partnerCompanyId)
    }
    this.$eventBus.$emit('refreshCar')
  }

  /**
   * 立即下单
   * */
  async placeOrder() {
    // const data = {
    //   companyId:this.companyId,
    //   storeList: []
    // }
    // data.storeList = [
    //   {
    //     companyId:this.companyId,
    //     storeId: this.defaultInfo.storeId,
    //     storeName: this.storeInfo.companyName,
    //     storeLogo: this.storeInfo.logoUrl,
    //     goodsPackageList: [
    //       {
    //         goodsId: this.goodsId,
    //         packageId: this.selectPackageInfo.packageId,
    //         orderQuantity: this.orderQuantity
    //       }
    //     ]
    //   }
    // ]
    // this.$router.push('/submitMallOrder')
  }

  changeQuantity (val, item) {
    if(val < item.sellUnit) {
      item.orderQuantity = 0
    }
    this.sellPrice(item)
  }
  async getCyGoodsSpecificationList () {
    const params = {
      storeId: this.$route.query.storeId || this.goodsDetail.storeId,
      goodsId: this.goodsId
    }

    const { data } = await getCyGoodsSpecificationList(params)
    data.packageList.forEach((item:any) => {
      // item.orderQuantity = item.orderQuantity > 1 ? item.orderQuantity : item.sellUnit
      this.sellPrice(item)
    })
    this.packageList = data.packageList
    this.packageList.forEach(p => {
      // 设置起订数量
      // p.orderQuantity = p.sellUnit
      p.orderQuantity = 0
    })
  }
  /**
   * 选择规格之后回到购物车，带回选择的规格和单价
   */
  async changeRuleSure() {
    // if (!this.isFullRule()) {
    //   return this.$toast('请选择规格')
    // }
    // this.$emit(
    //   'getSelectPackageInfo',
    //   this.selectPackageInfo,
    //   this.selectValueList
    // )
    // this.showRules = false
  }
   closeRules() {
    this.showRules = false
    // }).catch(() => { })
  }
}
